<template>
    <b-row>
        <b-col lg="4" md="12">
            <b-card>
                <h5 class="text-center"> اجمالي عدد الطلاب</h5>
                <h6 class="text-center">{{StudentsData.total_students}}</h6>
                <ul>
                    <li>المفعلين : {{StudentsData.activated_students}}</li>
                    <li>الغير مفعلين : {{StudentsData.deactivated_students}}</li>
                    <li>طلاب في مجموعات دراسية : {{StudentsData.student_in_groups}}</li>
                    <li>طلاب في برنامج : {{StudentsData.users_in_one_program}}</li>
                    <li>طلاب في اكثر من برنامج : {{StudentsData.users_in_more_than_one_program}}</li>
                </ul>
            </b-card>
            
        </b-col>
        <b-col lg="8" md="8" >
            <b-card>
                <h5 class="text-center"> اجمالي عدد المجموعات</h5>
                <h6 class="text-center">{{GroupsData.total_groups}}</h6>
                <b-table
                :stacked="$mobile == 1"
                :items="GroupsData.groups_data"
                :fields="groupsFields"
                >
                <template #cell(total_students)="data">
                    <h4>
                        <b-badge variant="primary">
                        {{ data.item.students_count }}
                        </b-badge>
                    </h4>
                    
                </template>
                <template #cell(total_teachers)="data">
                    <h4>
                        <b-badge variant="primary">
                        {{ data.item.teachers_count }}
                        </b-badge>
                    </h4>
                    
                </template>
                </b-table>
            </b-card>
        </b-col>
        <b-col lg="12">
            <b-card>
                <h5 class="text-center"> اجمالي عدد البرامج</h5>
                <h6 class="text-center">{{ProgramsData.total_programs}}</h6>
                <b-table
                :stacked="$mobile == 1"
                :items="ProgramsData.edu_programs"
                :fields="programsFields"
                >
                   <template #cell(total_semesters)="data">
                    <h4>
                        <b-badge variant="primary">
                        {{ data.item.semester.length }}
                        </b-badge>
                    </h4>
                    </template>
                    <template #cell(semester_details)="data">
                        <b-table
                        :stacked="$mobile == 1"
                        :items="data.item.semester"
                        :fields="[ 'الفصل' , 'عدد الطلاب','المواد']"
                        >
                        <template #cell(الفصل)="data">
                            {{ data.item.id }}
                        </template>
                        <template #cell(المواد)="data">
                            {{ data.item.courses_count }}
                        </template>
                        </b-table>
                        </template> 
                </b-table>
            </b-card>
        </b-col>
       
    </b-row>
   

</template>

<script>  
import UsersController from "@/Controllers/UsersController";
export default {
    name: 'FurqanStatics',
    async created(){
        let StudentsData = await new UsersController().getStudentsDataStatics();
        this.StudentsData = StudentsData.data.users_data;
        this.ProgramsData = StudentsData.data.programs_data;    
        this.GroupsData = StudentsData.data.groups_data;
    },
    data() {
        return {
            StudentsData:{},
            ProgramsData:{},
            GroupsData:{},
            programsFields : [
                {
                    key: "name",
                    label: "اسم البرنامج",
                },
                {
                    key: "total_semesters",
                    label: "عدد الفصول",
                },
                {
                    key : "semester_details",
                    label : "تفاصيل الفصول"
                }
            ],
            groupsFields : [
                {
                    key: "name",
                    label: "اسم المجموعة",
                },
                {
                    key: "total_students",
                    label: "عدد الطلاب",
                },
                {
                    key: "total_teachers",
                    label: "عدد الاستاذة",
                },
             
            ]
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>

<style lang="scss" scoped>
  
    h5,h6 {
        font-size:25px;
        font-family: 'Tajawal', sans-serif;
    }
    ul li {
        font-size:20px;
        font-family: 'Tajawal', sans-serif;
        font-weight: bold;
    }
   
</style>